// extracted by mini-css-extract-plugin
export default {"header":"BoardListViewHeader_header__YJoB1","headerCol":"BoardListViewHeader_headerCol__oxjoR","row":"BoardListViewHeader_row__+X4bc","col":"BoardListViewHeader_col__NZBg6"};